


const roundOff = num => {
    if (num > 1000000000) {
      return Math.round(num / 100000000) / 10 + 'Bn';
    } else if (num > 1000000) {
      return Math.round(num / 100000) / 10 + 'M';
    } else if (num > 1000) {
      return Math.round(num / 100) / 10 + 'K';
    } 
    return num;
};

const wholeNumber = num => num.toLocaleString();

export default roundOff;
export {wholeNumber};